<script>
	const defLocation=[114.171202,22.277469]
	const accountNatureTypeList=["signing", "business", "release", "affiliated"]
	
	export default{
	  	defLocation,
		accountNatureTypeList
	}
</script>



// WEBPACK FOOTER //
// src/components/tool/Global.vue